class OccasionTabsNav extends HTMLElement {
  constructor() {
    super();
    this.tabs = Array.from(this.querySelectorAll('.occasion-tabs__tab'));
    this.viewAllLink = this.closest('.occasion-tabs')?.querySelector('[data-occasion-tabs-view-all]');
    this.tabs.forEach((tab) => tab.addEventListener('click', this.onTabClick.bind(this)));
  }

  onTabClick(event) {
    const clickedTab = event.currentTarget;
    if (clickedTab.classList.contains('occasion-tabs__tab--active')) return;

    this.tabs.forEach((tab) => {
      const isActive = tab === clickedTab;
      tab.classList.toggle('occasion-tabs__tab--active', isActive);
      tab.setAttribute('aria-selected', isActive);

      const panel = document.getElementById(tab.getAttribute('data-tab-target'));
      if (!panel) return;

      panel.classList.toggle('occasion-tabs__panel--active', isActive);
      if (isActive) {
        panel.removeAttribute('hidden');
        panel.querySelectorAll('card-slider').forEach((cardSlider) => {
          if (typeof cardSlider.connectedCallback === 'function') {
            cardSlider.connectedCallback();
          }
        });
      } else {
        panel.setAttribute('hidden', '');
      }
    });

    if (this.viewAllLink && clickedTab.dataset.collectionUrl) {
      this.viewAllLink.setAttribute('href', clickedTab.dataset.collectionUrl);
    }
  }
}

customElements.define('occasion-tabs-nav', OccasionTabsNav);
